/* Componenti home Italo Vezzoli — replica dei comportamenti Swiper dell'headless
   (slideshow fade + autoplay, caroselli scroll-snap, step preparazione, lightbox,
   add-to-cart dalle card). */

(function () {
  'use strict';

  /* ---- Slideshow hero: replica dello Swiper headless (misurato sul live):
     effect fade con crossFade=false (la slide nuova sfuma 0→1 in 300ms SOPRA
     la vecchia, che resta visibile sotto fino a fine fade), autoplay 10s che
     NON si ferma sull'hover né sull'interazione (disableOnInteraction:false),
     frecce prev/next nascoste quando disabilitate (niente loop: prev nascosta
     sulla prima, next sull'ultima; l'autoplay invece riparte da capo). ---- */
  class IvSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.iv-hero__slide'));
      this.dotsWrap = this.querySelector('.iv-hero__dots');
      this.index = 0;
      if (this.slides.length < 2) {
        if (this.dotsWrap) this.dotsWrap.hidden = true;
        return;
      }
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'iv-hero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => this.go(i, true));
        this.dotsWrap.appendChild(dot);
      });
      this.prevBtn = this.makeArrow('prev');
      this.nextBtn = this.makeArrow('next');
      this.updateArrows();
      this.syncInert();
      // Accessibilità (WCAG 2.2.2): l'autoplay si ferma col pulsante pausa, mentre il
      // focus o il mouse sono dentro lo slideshow, e non parte con "riduci movimento".
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseBtn = document.createElement('button');
      this.pauseBtn.type = 'button';
      this.pauseBtn.className = 'iv-hero__pause';
      this.pauseBtn.addEventListener('click', () => {
        this.paused = !this.paused;
        this.syncPause();
        if (this.paused) this.stop();
        else this.start();
      });
      this.dotsWrap.appendChild(this.pauseBtn);
      this.syncPause();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.start();
      });
      this.start();
    }
    syncPause() {
      this.pauseBtn.classList.toggle('is-paused', this.paused);
      this.pauseBtn.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    syncInert() {
      // Le slide non attive sono solo trasparenti: senza inert i loro link restano raggiungibili da tastiera
      this.slides.forEach((s, j) => s.toggleAttribute('inert', j !== this.index));
    }
    makeArrow(dir) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iv-hero__arrow iv-hero__arrow--' + dir;
      btn.setAttribute('aria-label', dir === 'prev' ? 'Slide precedente' : 'Slide successiva');
      // Nessun SVG: il glifo arriva da ::after col font swiper-icons, come l'ufficiale
      btn.addEventListener('click', () => this.go(this.index + (dir === 'next' ? 1 : -1), true));
      this.appendChild(btn);
      return btn;
    }
    updateArrows() {
      if (!this.prevBtn) return;
      this.prevBtn.hidden = this.index === 0;
      this.nextBtn.hidden = this.index === this.slides.length - 1;
    }
    disconnectedCallback() {
      this.stop();
    }
    start() {
      const delay = parseInt(this.dataset.autoplay || '10000', 10);
      this.stop();
      if (this.paused) return;
      this.timer = setInterval(() => this.go(this.index + 1), delay);
    }
    stop() {
      if (this.timer) clearInterval(this.timer);
    }
    go(i, manual) {
      const prev = this.index;
      this.index = (i + this.slides.length) % this.slides.length;
      if (prev !== this.index) {
        clearTimeout(this.wasTimer);
        this.slides.forEach((s) => s.classList.remove('iv-was-active'));
        this.slides[prev].classList.add('iv-was-active');
        this.wasTimer = setTimeout(() => {
          this.slides.forEach((s) => s.classList.remove('iv-was-active'));
        }, 320);
      }
      this.slides.forEach((s, j) => s.classList.toggle('is-active', j === this.index));
      this.syncInert();
      this.dotsWrap
        .querySelectorAll('.iv-hero__dot')
        .forEach((d, j) => {
          d.classList.toggle('is-active', j === this.index);
          if (j === this.index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      this.updateArrows();
      if (manual) this.start();
    }
  }
  customElements.define('iv-slideshow', IvSlideshow);

  /* ---- Carosello scroll-snap con frecce e dots ---- */
  class IvCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.iv-carousel__track');
      this.items = Array.from(this.querySelectorAll('.iv-carousel__item'));
      const prev = this.querySelector('.iv-carousel__prev');
      const next = this.querySelector('.iv-carousel__next');
      this.prevBtn = prev;
      this.nextBtn = next;
      if (prev) prev.addEventListener('click', () => this.scrollByItem(-1));
      if (next) next.addEventListener('click', () => this.scrollByItem(1));
      // Frecce disabilitate ai capi come Swiper (isBeginning/isEnd) + il
      // `disabled:opacity-30 disabled:pointer-events-none` della cva del Button:
      // misurato sul live, prev è disabled sulla prima slide e next sull'ultima.
      if (prev || next) {
        this.syncArrows();
        this.track.addEventListener(
          'scroll',
          () => {
            clearTimeout(this._at);
            this._at = setTimeout(() => this.syncArrows(), 60);
          },
          {passive: true}
        );
        this._aro = new ResizeObserver(() => this.syncArrows());
        this._aro.observe(this.track);
      }
      this.dotsWrap = this.querySelector('.iv-carousel__dots');
      if (this.dotsWrap) {
        this.buildDots();
        this.track.addEventListener(
          'scroll',
          () => {
            clearTimeout(this._t);
            this._t = setTimeout(() => this.syncDots(), 80);
          },
          {passive: true}
        );
        // Come Swiper, il numero di bullet dipende da quante card stanno nel
        // track: al resize gli snap cambiano e la paginazione va ricostruita.
        this._ro = new ResizeObserver(() => {
          clearTimeout(this._rt);
          this._rt = setTimeout(() => this.buildDots(), 120);
        });
        this._ro.observe(this.track);
      }
    }
    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._aro) this._aro.disconnect();
    }
    syncArrows() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const x = this.track.scrollLeft;
      // 1px di tolleranza: gli offset di scroll sono frazionari
      if (this.prevBtn) this.prevBtn.disabled = x <= 1;
      if (this.nextBtn) this.nextBtn.disabled = x >= max - 1;
    }
    /* Punti di snap alla Swiper (snapGrid): l'offset di ogni card, ma quelli
       oltre lo scroll massimo vengono schiacciati sul massimo e deduplicati.
       Con 6 card da 405+15 in un track da 825: 0,420,840,1260,1680,(2100→1680)
       → 5 snap, cioè i 5 bullet dell'ufficiale (prima ne facevamo 6, uno per
       prodotto, e il sesto non portava da nessuna parte). */
    snaps() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const base = this.track.offsetLeft;
      const out = [];
      this.items.forEach((it) => {
        const at = Math.min(it.offsetLeft - base, max);
        if (!out.length || Math.abs(at - out[out.length - 1]) > 1) out.push(at);
      });
      return out;
    }
    buildDots() {
      const snaps = this.snaps();
      this.dotsWrap.innerHTML = '';
      // .swiper-pagination-lock: con un solo snap la paginazione è nascosta
      this.dotsWrap.hidden = snaps.length <= 1;
      if (snaps.length <= 1) return;
      snaps.forEach((at, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'iv-carousel__dot';
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', () => this.track.scrollTo({left: at, behavior: 'smooth'}));
        this.dotsWrap.appendChild(d);
      });
      this.syncDots();
    }
    syncDots() {
      const snaps = this.snaps();
      const x = this.track.scrollLeft;
      let active = 0;
      snaps.forEach((at, i) => {
        if (Math.abs(at - x) < Math.abs(snaps[active] - x)) active = i;
      });
      this.dotsWrap
        .querySelectorAll('.iv-carousel__dot')
        .forEach((d, i) => {
          d.classList.toggle('is-active', i === active);
          if (i === active) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
    }
    scrollByItem(dir) {
      const w = this.items[0] ? this.items[0].offsetWidth + 15 : this.track.clientWidth;
      this.track.scrollBy({left: dir * w, behavior: 'smooth'});
    }
  }
  customElements.define('iv-carousel', IvCarousel);

  /* ---- Gallery full-width con frecce centrali ---- */
  /* Come lo Swiper headless: track flex traslato -100%×indice (300ms ease),
     bottoni prev/next dentro OGNI slide (scorrono con la slide), nascosti ai
     bordi (prev sulla prima, next sull'ultima). */
  class IvGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.iv-gallery2__slides');
      this.slides = Array.from(this.querySelectorAll('.iv-gallery2__slide'));
      this.prevBtns = Array.from(this.querySelectorAll('.iv-gallery2__prev'));
      this.nextBtns = Array.from(this.querySelectorAll('.iv-gallery2__next'));
      this.index = 0;
      this.prevBtns.forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.nextBtns.forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      this.update();
    }
    go(i) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.style.transform = 'translateX(' + -100 * this.index + '%)';
      this.slides.forEach((s, j) => s.classList.toggle('is-active', j === this.index));
      this.update();
    }
    update() {
      this.prevBtns.forEach((b) => (b.hidden = this.index === 0));
      this.nextBtns.forEach((b) => (b.hidden = this.index === this.slides.length - 1));
    }
  }
  customElements.define('iv-gallery', IvGallery);

  /* ---- Step preparazione: desktop click su step → fade immagine 0.9s;
     mobile swiper 1-per-view (scroll-snap) con dots 30×3 e immagine sotto ---- */
  class IvPrepSteps extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.iv-prep__step'));
      this.imgs = Array.from(this.querySelectorAll('.iv-prep__image img'));
      this.track = this.querySelector('.iv-prep__steps');
      this.steps.forEach((btn) => {
        btn.addEventListener('click', () => this.select(parseInt(btn.dataset.index, 10)));
      });
      // Dots mobile (come la pagination Swiper dell'headless, cliccabile)
      this.dotsWrap = document.createElement('div');
      this.dotsWrap.className = 'iv-prep__dots';
      this.steps.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'iv-prep__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Step ' + (i + 1));
        dot.addEventListener('click', () => this.scrollToStep(i));
        this.dotsWrap.appendChild(dot);
      });
      this.track.after(this.dotsWrap);
      // Sync su swipe (snap): larghezza slide = clientWidth, gap 30
      this.track.addEventListener(
        'scroll',
        () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            const stepW = this.track.clientWidth + 30;
            this.select(Math.round(this.track.scrollLeft / stepW));
          }, 80);
        },
        {passive: true}
      );
    }
    scrollToStep(i) {
      this.track.scrollTo({left: i * (this.track.clientWidth + 30), behavior: 'smooth'});
    }
    select(i) {
      if (i < 0 || i >= this.steps.length) return;
      this.steps.forEach((b, j) => b.classList.toggle('is-active', j === i));
      this.imgs.forEach((im, j) => im.classList.toggle('is-active', j === i));
      this.dotsWrap.querySelectorAll('.iv-prep__dot').forEach((d, j) => d.classList.toggle('is-active', j === i));
    }
  }
  customElements.define('iv-prep-steps', IvPrepSteps);

  /* ---- Lightbox immagini (anche da tastiera: Invio/Spazio apre, Esc chiude, focus sul Chiudi e poi di ritorno) ---- */
  let lightboxFrom = null;
  const openLightbox = (src, box) => {
    lightboxFrom = src;
    box.querySelector('img').src = src.currentSrc || src.src;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    const close = box.querySelector('.iv-lightbox__close');
    if (close) close.focus();
  };
  const closeLightbox = (box) => {
    box.hidden = true;
    document.body.style.overflow = '';
    if (lightboxFrom && document.contains(lightboxFrom)) lightboxFrom.focus();
    lightboxFrom = null;
  };
  document.addEventListener('click', (e) => {
    const src = e.target.closest('.iv-lightbox-src');
    const box = document.querySelector('.iv-lightbox');
    if (src && box) {
      openLightbox(src, box);
      return;
    }
    if (box && !box.hidden && (e.target.closest('.iv-lightbox__close') || e.target === box)) closeLightbox(box);
  });
  document.addEventListener('keydown', (e) => {
    const box = document.querySelector('.iv-lightbox');
    if (!box) return;
    if (!box.hidden) {
      if (e.key === 'Escape') closeLightbox(box);
      // un solo elemento attivo nella finestra: il Tab resta sul Chiudi
      if (e.key === 'Tab') {
        e.preventDefault();
        const close = box.querySelector('.iv-lightbox__close');
        if (close) close.focus();
      }
      return;
    }
    const src = e.target.closest && e.target.closest('.iv-lightbox-src');
    if (!src) return;
    if (e.key === ' ') e.preventDefault(); // niente scroll: con Spazio si apre al rilascio, come un vero pulsante
    if (e.key === 'Enter' && !e.repeat) {
      e.preventDefault();
      openLightbox(src, box);
    }
  });
  document.addEventListener('keyup', (e) => {
    const box = document.querySelector('.iv-lightbox');
    const src = e.target.closest && e.target.closest('.iv-lightbox-src');
    if (box && box.hidden && src && e.key === ' ') openLightbox(src, box);
  });

  /* ---- Play/pausa video carosello ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.iv-videocar__play');
    if (!btn) return;
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
  // Stato del pulsante dal video stesso (anche a fine riproduzione): aria-pressed per i lettori di schermo
  document.querySelectorAll('.iv-videocar__video').forEach((video) => {
    const btn = video.parentElement.querySelector('.iv-videocar__play');
    if (!btn) return;
    const sync = () => {
      btn.classList.toggle('is-playing', !video.paused);
      btn.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
  });

  /* ---- Add to cart dalle card (replica AddToCartButton + cart notification Dawn) ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.iv-add-to-cart');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    // Card esaurita: sul live il bottone è cliccabile e NON aggiunge nulla
    // (nessun drawer, nessun toast) — product-card.tsx:94 esce subito — ma il
    // CartForm parte comunque con `lines: []`, e AddToCartButton lo tiene
    // `disabled={fetcher.state !== 'idle'}` → misurato sull'ufficiale: si
    // spegne a opacity .3 per la durata del giro (~650ms) e poi torna.
    // Qui la stessa cosa con una richiesta innocua (GET del carrello).
    if (btn.dataset.unavailable === 'true') {
      btn.disabled = true;
      const done = () => {
        btn.disabled = false;
      };
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(done)
        .catch(done);
      return;
    }
    btn.disabled = true;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let qty = 1;
    if (btn.dataset.qtyFrom) {
      const qtyInput = document.getElementById(btn.dataset.qtyFrom);
      if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;
    }
    const body = {
      id: parseInt(btn.dataset.variantId, 10),
      quantity: qty,
    };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || 'add error');
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        // toast sonner insieme all'apertura del drawer (form.tsx:88-89,
        // product-card.tsx:97 dell'headless)
        if (window.ivToast && btn.dataset.toast) window.ivToast(btn.dataset.toast);
      })
      .catch(() => {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(() => {
        btn.disabled = false;
      });
  });
})();

/* SectionTitle del carousel_text: sull'ufficiale la <section> è STATIC e il
   wrapper della label (absolute top-1/2) si ancora al div h-screen del layout
   → la label sta sempre a 50vh dal top del DOCUMENTO, ovunque sia la sezione
   (misurato su la-nostra-storia: wrapper top=500 con viewport 1000, section a
   y=228). Qui la section è position:relative, quindi si compensa via JS. */
(() => {
  function position() {
    document.querySelectorAll('.iv-textcar > .iv-section-label').forEach((el) => {
      const sec = el.closest('.iv-textcar');
      const secY = sec.getBoundingClientRect().top + window.scrollY;
      el.style.top = window.innerHeight / 2 - secY + 'px';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', position);
  } else {
    position();
  }
  window.addEventListener('resize', position);
  window.addEventListener('load', position);
})();
